<template>
  <v-container fluid class="dashboard-container">
    <v-card class="pa-4 elevation-6">
      <v-row class="align-center">
        <v-col cols="12" md="6">
          <h2 class="text-h5 font-weight-bold">Periféricos</h2>
        </v-col>
        <v-col cols="12" md="6" class="d-flex justify-end">
          <v-btn v-if="puedeGestionarPerifericos" color="secondary" @click="manejarClickAgregar">
            <v-icon left>mdi-plus</v-icon>
            Agregar periférico
          </v-btn>
        </v-col>
      </v-row>

      <v-row class="align-center">
        <v-col cols="12" md="4">
          <v-text-field
            v-model="search"
            label="Buscar periférico..."
            prepend-icon="mdi-magnify"
            clearable
            dense
            hide-details
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-select
            v-model="ordenSeleccionado"
            :items="opcionesOrden"
            label="Ordenar por"
            dense
            hide-details
          />
        </v-col>
        <v-col cols="12" md="5" class="d-flex align-center">
          <v-chip-group v-model="estadoFiltro" active-class="primary--text" mandatory>
            <v-chip :value="'todos'" outlined>Todos</v-chip>
            <v-chip :value="'disponible'" outlined>Disponibles</v-chip>
            <v-chip :value="'asignado'" outlined>Asignados</v-chip>
          </v-chip-group>
        </v-col>
      </v-row>

      <v-divider class="my-3"></v-divider>

      <!-- Tarjetas -->
      <v-row>
        <v-col v-for="p in perifericosPaginados" :key="p.id" cols="12" sm="6" md="4" lg="3">
          <v-hover v-slot="{ hover }">
            <div class="peripheral-card" :class="[peripheralThemeClass, { 'peripheral-card--hover': hover }]">
              <div class="peripheral-image" @click.stop="abrirDialogoEdicion(p)">
                <v-img :src="getPeripheralImage(p)" height="160" contain>
                  <div class="peripheral-status">
                    <v-chip :color="p.estado === 'asignado' ? 'blue' : 'green'" dark small>
                      {{ p.estado === 'asignado' ? 'Asignado' : 'Disponible' }}
                    </v-chip>
                  </div>
                </v-img>
              </div>

              <div class="peripheral-body">
                <div class="title">
                  {{ p.nombre || "Periférico sin nombre" }}
                </div>
                <div class="meta">
                  <div><span class="k">Tipo:</span> {{ p.tipo || "—" }}</div>
                  <div><span class="k">Marca:</span> {{ p.marca || "—" }}</div>
                  <div><span class="k">Modelo:</span> {{ p.modelo || "—" }}</div>
                </div>
                <div class="assigned">
                  <v-icon small class="mr-1">mdi-account</v-icon>
                  <span class="k">Asignado a:</span>
                  <span class="v">{{ p.asignado_a || "No asignado" }}</span>
                </div>
              </div>
            </div>
          </v-hover>
        </v-col>
      </v-row>

      <v-divider class="my-4"></v-divider>

      <v-row align="center">
        <v-col cols="12" md="4">
          <v-select v-model="itemsPerPage" :items="itemsPerPageOptions" label="Mostrar" dense hide-details
            style="max-width: 140px" />
        </v-col>
        <v-col cols="12" md="4" class="text-center">
          <v-pagination v-if="!esAll && totalPages > 1" v-model="page" :length="totalPages" />
        </v-col>
        <v-col cols="12" md="4" class="d-flex justify-end">
          <v-btn color="grey darken-3" @click="volverInicio">
            <v-icon left>mdi-home</v-icon>
            Volver a Inicio
          </v-btn>
        </v-col>
      </v-row>

      <!-- Diálogo para Agregar Periférico -->
      <v-dialog v-model="dialogAgregar" max-width="600px">
        <v-card>
          <v-card-title class="headline grey lighten-2">
            Agregar Periférico
          </v-card-title>

          <v-card-text>
            <v-form @submit.prevent="crearPeriferico">
              <v-combobox
                v-model="nuevoPeriferico.nombre"
                :items="perifericosUnicosPorNombre"
                item-text="label"
                item-value="nombre"
                label="Nombre"
                clearable
                @change="autocompletarPeriferico"
                required
              />
              <v-select v-model="nuevoPeriferico.tipo" :items="['Monitor', 'Mouse', 'Teclado', 'USB HUB', 'Auriculares']"
                label="Tipo" required />
              <v-text-field v-model="nuevoPeriferico.marca" label="Marca" required />
              <v-text-field v-model="nuevoPeriferico.modelo" label="Modelo" required />
              <v-text-field v-model.number="nuevoPeriferico.cantidad" label="Cantidad" type="number" min="1" required />
              <v-file-input
                v-model="nuevoPeriferico.imagenFile"
                label="Imagen del periférico"
                accept="image/*"
                prepend-icon="mdi-image"
                @change="manejarImagenSeleccionada"
              />
              <v-img
                v-if="nuevoPeriferico.imagen"
                :src="nuevoPeriferico.imagen"
                max-height="160"
                contain
                class="mb-2"
              />
              <v-text-field v-if="nuevoPeriferico.tipo === 'Monitor'" v-model="nuevoPeriferico.tamano_pantalla"
                label="Tamaño de Pantalla" />
              <v-text-field v-if="nuevoPeriferico.tipo === 'Monitor'" v-model="nuevoPeriferico.soporte"
                label="Soporte" />
              <v-text-field v-if="nuevoPeriferico.tipo === 'Monitor'" v-model="nuevoPeriferico.tecnologia_pantalla"
                label="Tecnología de Pantalla" />
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text color="grey" @click="dialogAgregar = false">Cancelar</v-btn>
            <v-btn color="primary" @click="crearPeriferico">Agregar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


      <!-- Diálogo Detalle de Periférico con Tabs -->
      <v-dialog v-model="dialogDetallePeriferico" max-width="800" scrollable>
        <v-card class="d-flex flex-column" style="max-height: 85vh;">

          <!-- Tabs superiores -->
          <v-tabs v-model="tabDetalle" background-color="blue lighten-4" grow>
            <v-tab>Detalles</v-tab>
            <v-tab>Asignar</v-tab>
            <v-tab>Historial</v-tab>
            <v-tab>Modificar</v-tab>
          </v-tabs>

          <!-- Contenedor scroll interno -->
          <div class="dialog-scroll-container">
            <v-tabs-items v-model="tabDetalle">
              <!-- Detalles -->
              <v-tab-item>
                <v-card flat class="pa-4" v-if="perifericoSeleccionado">
                  <v-img
                    v-if="getPeripheralImage(perifericoSeleccionado)"
                    :src="getPeripheralImage(perifericoSeleccionado)"
                    max-height="200"
                    contain
                    class="mb-4"
                  />
                  <p><strong>ID:</strong> {{ perifericoSeleccionado.id }}</p>
                  <p><strong>Nombre:</strong> {{ perifericoSeleccionado.name }}</p>
                  <p><strong>Tipo:</strong> {{ perifericoSeleccionado.type }}</p>
                  <p><strong>Marca:</strong> {{ perifericoSeleccionado.marca }}</p>
                  <p><strong>Modelo:</strong> {{ perifericoSeleccionado.modelo }}</p>
                  <p v-if="perifericoSeleccionado.tipo === 'Monitor'"><strong>Tamaño:</strong> {{
                    perifericoSeleccionado.tamano_pantalla }}</p>
                  <p v-if="perifericoSeleccionado.tipo === 'Monitor'"><strong>Soporte:</strong> {{
                    perifericoSeleccionado.soporte }}</p>
                  <p v-if="perifericoSeleccionado.tipo === 'Monitor'"><strong>Tecnología:</strong> {{
                    perifericoSeleccionado.tecnologia_pantalla }}</p>
                </v-card>
                <v-card flat class="pa-4 text-center text-grey" v-else>
                  <p>No hay datos disponibles del periférico seleccionado.</p>
                </v-card>
              </v-tab-item>

              <!-- Asignar -->
              <v-tab-item>
                <v-card flat class="pa-4" v-if="puedeGestionarPerifericos">
                  <v-autocomplete
                    v-model="colaboradorSeleccionado"
                    :items="colaboradores"
                    item-text="nombre_completo"
                    item-value="id"
                    label="Buscar colaborador"
                    clearable
                    dense
                    hide-no-data
                    hide-details="auto"
                  />
                  <v-btn color="primary" class="mt-4" @click="asignarPerifericoDesdeDetalle">
                    <v-icon left>mdi-link</v-icon> Asignar
                  </v-btn>
                </v-card>
                <v-card flat class="pa-4 text-center" v-else>
                  <v-icon size="60" color="grey lighten-1">mdi-lock</v-icon>
                  <p class="mt-4">No tienes permisos para asignar periféricos.</p>
                </v-card>
              </v-tab-item>

              <!-- Historial -->
              <v-tab-item>
                <v-card flat class="pa-4">
                  <v-list dense
                    v-if="perifericoSeleccionado && perifericoSeleccionado.log && perifericoSeleccionado.log.length">
                    <v-list-item v-for="(entry, index) in perifericoSeleccionado.log" :key="index">
                      <v-list-item-icon>
                        <v-icon color="primary">mdi-history</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ new Date(entry.timestamp).toLocaleString('es-CL', { timeZone: 'America/Santiago' }) }}
                        </v-list-item-title>
                        <span v-if="entry.action === 'CREADO'">
                          PERIFÉRICO CREADO
                        </span>
                        <span v-else-if="entry.action === 'ASIGNADO'">
                          ASIGNADO de {{ entry.from || 'No asignado' }} a {{ entry.to || 'No asignado' }}
                        </span>
                        <span v-else>
                          {{ entry.action }} de {{ entry.from || 'N/A' }} a {{ entry.to || 'N/A' }}
                        </span>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <div v-else class="text-center grey--text">
                    No hay historial disponible.
                  </div>
                </v-card>
              </v-tab-item>

              <!-- Modificar / Eliminar -->
              <v-tab-item v-if="puedeGestionarPerifericos">
                <v-card flat class="pa-4">
                  <v-form @submit.prevent="guardarCambiosPeriferico">
                    <v-text-field v-model="perifericoSeleccionado.nombre" label="Nombre" />
                    <v-text-field v-model="perifericoSeleccionado.tipo" label="Tipo" />
                    <v-text-field v-model="perifericoSeleccionado.marca" label="Marca" />
                    <v-text-field v-model="perifericoSeleccionado.modelo" label="Modelo" />
                    <v-file-input
                      v-model="perifericoSeleccionado.imagenFile"
                      label="Imagen del periférico"
                      accept="image/*"
                      prepend-icon="mdi-image"
                      @change="manejarImagenEdicion"
                    />
                    <v-img
                      :src="getPeripheralImage(perifericoSeleccionado)"
                      max-height="160"
                      contain
                      class="mb-2"
                    />
                    <v-text-field v-if="perifericoSeleccionado.tipo === 'Monitor'"
                      v-model="perifericoSeleccionado.tamano_pantalla" label="Tamaño de Pantalla" />
                    <v-text-field v-if="perifericoSeleccionado.tipo === 'Monitor'"
                      v-model="perifericoSeleccionado.soporte" label="Soporte" />
                    <v-text-field v-if="perifericoSeleccionado.tipo === 'Monitor'"
                      v-model="perifericoSeleccionado.tecnologia_pantalla" label="Tecnología de Pantalla" />
                    <v-card-actions class="justify-end mt-4">
                      <v-btn color="green" type="submit">
                        <v-icon left>mdi-content-save</v-icon> Guardar Cambios
                      </v-btn>
                      <v-btn color="red" @click="abrirDialogoConfirmarEliminar(perifericoSeleccionado)">
                        <v-icon left>mdi-delete</v-icon> Eliminar Periférico
                      </v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-tab-item>
              <!-- Mostrar mensaje si el usuario NO es admin -->
              <v-tab-item v-else>
                <v-card flat class="pa-4 text-center">
                  <v-icon size="60" color="grey lighten-1">mdi-lock</v-icon>
                  <p class="mt-4">No tienes permisos para modificar o eliminar Perifericos.</p>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </div>


          <!-- Botón de cerrar abajo si quieres -->
          <v-card-actions class="justify-end">
            <v-btn text color="grey" @click="dialogDetallePeriferico = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOGO CONFIRMACIÓN ELIMINACIÓN DEL PERIFÉRICO -->
      <v-dialog v-model="dialogConfirmarEliminarUno" max-width="500">
        <v-card>
          <v-card-title class="headline">¿Eliminar periférico?</v-card-title>
          <v-card-text>
            Esta acción eliminará el periférico seleccionado. ¿Estás seguro de que deseas continuar?
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="dialogConfirmarEliminarUno = false">Cancelar</v-btn>
            <v-btn color="red" @click="confirmarEliminarPeriferico">
              <v-icon left>mdi-delete</v-icon> Eliminar Periférico
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="4000">
        {{ snackbarMensaje }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
        </template>
      </v-snackbar>

    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import API_BASE from "@/helpers/api";

export default {
  data() {
    return {
      perifericos: [],
      usuario: JSON.parse(localStorage.getItem("usuario")),
      dialogDetallePeriferico: false,
      tabDetalle: 0,
      search: "",
      dialogAgregar: false,
      mensajeError: "Ocurrió un error al asignar el periférico.",
      dialogSinPermisos: false,
      dialogAsignar: false,
      perifericoPendienteEliminar: null,
      colaboradorSeleccionado: null,
      perifericoSeleccionado: {},
      colaboradores: [],
      perifericosDisponibles: [],
      dialogConfirmarEliminarUno: false,

      page: 1,
      itemsPerPage: 12,
      itemsPerPageOptions: [
        { text: "12", value: 12 },
        { text: "24", value: 24 },
        { text: "36", value: 36 },
        { text: "100", value: 100 },
        { text: "All", value: -1 },
      ],
      ordenSeleccionado: "Fecha: más recientes",
      estadoFiltro: "todos",
      opcionesOrden: [
        "Fecha: más recientes",
        "Fecha: más antiguos",
        "Tipo: teclado > monitor > mouse",
        "Tipo: A-Z",
        "Nombre: A-Z",
        "Nombre: Z-A",
      ],

      snackbar: false,
      snackbarMensaje: "",
      snackbarColor: "success",
      nuevoPeriferico: {
        nombre: "",
        tipo: "",
        marca: "",
        modelo: "",
        cantidad: 1,
        tamano_pantalla: "",
        soporte: "",
        tecnologia_pantalla: "",
        imagen: "",
        imagenFile: null,
      },
    };
  },
  computed: {
    puedeGestionarPerifericos() {
      const rol = (this.usuario?.rol || "").trim().toLowerCase();
      return rol === "adminti";
    },
    esAdminTI() {
      return this.usuario && this.usuario.rol && String(this.usuario.rol).trim().toLowerCase() === "adminti";
    },

    perifericosUnicosPorNombre() {
      const map = new Map();
      for (const p of this.perifericos) {
        const key = (p.nombre || "").trim().toLowerCase();
        if (!key || map.has(key)) continue;
        map.set(key, {
          ...p,
          label: `${p.nombre}${p.tipo ? ` (${p.tipo}` : ""}${p.marca ? ` - ${p.marca}` : ""}${p.modelo ? ` ${p.modelo}` : ""}${p.tipo ? ")" : ""}`
        });
      }
      return Array.from(map.values());
    },

    perifericosFiltrados() {
      const texto = (this.search || "").toLowerCase().trim();
      const base = !texto
        ? [...this.perifericos]
        : this.perifericos.filter(p =>
          (p.nombre || "").toLowerCase().includes(texto) ||
          (p.tipo || "").toLowerCase().includes(texto) ||
          (p.marca || "").toLowerCase().includes(texto) ||
          (p.modelo || "").toLowerCase().includes(texto) ||
          (p.asignado_a || "").toLowerCase().includes(texto) ||
          String(p.id || "").includes(texto)
        );

      const filtrados = this.estadoFiltro === "todos"
        ? base
        : base.filter(p => (p.estado || "").toLowerCase() === this.estadoFiltro);

      return this.ordenarPerifericos(filtrados);
    },
    esAll() {
      return Number(this.itemsPerPage) === -1;
    },
    totalPages() {
      if (this.esAll) return 1;
      const per = Number(this.itemsPerPage) || 20;
      return Math.max(1, Math.ceil(this.perifericosFiltrados.length / per));
    },
    perifericosPaginados() {
      if (this.esAll) return this.perifericosFiltrados;
      const per = Number(this.itemsPerPage) || 20;
      const start = (this.page - 1) * per;
      return this.perifericosFiltrados.slice(start, start + per);
    },
    peripheralThemeClass() {
      return this.$vuetify.theme.dark
        ? "peripheral-card--dark"
        : "peripheral-card--light";
    },
  },
  watch: {
    search() {
      this.page = 1;
    },
    itemsPerPage() {
      this.page = 1;
    },
    totalPages(newVal) {
      if (this.page > newVal) this.page = newVal;
    },
    ordenSeleccionado() {
      this.page = 1;
    },
  },
  methods: {
    ordenarPerifericos(lista) {
      const orden = this.ordenSeleccionado;
      const tipoPrioridad = ["teclado", "monitor", "mouse"];

      const byText = (a, b, field) =>
        String(a[field] || "")
          .toLowerCase()
          .localeCompare(String(b[field] || "").toLowerCase(), "es");

      switch (orden) {
        case "Fecha: más antiguos":
          return lista.sort((a, b) => (a.id || 0) - (b.id || 0));
        case "Tipo: teclado > monitor > mouse":
          return lista.sort((a, b) => {
            const ta = tipoPrioridad.indexOf(String(a.tipo || "").toLowerCase());
            const tb = tipoPrioridad.indexOf(String(b.tipo || "").toLowerCase());
            const pa = ta === -1 ? 999 : ta;
            const pb = tb === -1 ? 999 : tb;
            if (pa !== pb) return pa - pb;
            return byText(a, b, "nombre");
          });
        case "Tipo: A-Z":
          return lista.sort((a, b) => byText(a, b, "tipo"));
        case "Nombre: Z-A":
          return lista.sort((a, b) => -byText(a, b, "nombre"));
        case "Nombre: A-Z":
          return lista.sort((a, b) => byText(a, b, "nombre"));
        case "Fecha: más recientes":
        default:
          return lista.sort((a, b) => (b.id || 0) - (a.id || 0));
      }
    },
    perifericoKey(periferico) {
      if (!periferico) return "";
      const nombre = (periferico.nombre || "").trim().toLowerCase();
      const tipo = (periferico.tipo || "").trim().toLowerCase();
      const marca = (periferico.marca || "").trim().toLowerCase();
      const modelo = (periferico.modelo || "").trim().toLowerCase();
      return `${nombre}||${tipo}||${marca}||${modelo}`;
    },
    async obtenerPerifericos() {
      try {
        const response = await axios.get(`${API_BASE}/perifericos`);
        this.perifericos = response.data.map(p => ({
          ...this.parseDescription(p.description, p.type),
          id: p.id,
          nombre: p.name,
          tipo: p.type,
          marca: p.brand,
          modelo: p.model,
          estado: p.status,
          asignado_a: p.nombre_colaborador || "No asignado",
          log: (() => {
            try {
              return typeof p.log === "string" ? JSON.parse(p.log) : (p.log || []);
            } catch {
              return [];
            }
          })(),
          // Campos extra opcionales
          name: p.name,
          type: p.type,
          brand: p.brand,
          model: p.model,
          status: p.status,
          description: p.description,
          image_url: p.image_url || ""
        }));
      } catch (error) {
        console.error("❌ Error al obtener periféricos:", error);
        this.snackbarMensaje = "❌ Error al obtener periféricos.";
        this.snackbarColor = "error";
        this.snackbar = true;
      }
    },
    async abrirDialogoEdicion(item) {
      try {
        const res = await axios.get(`${API_BASE}/perifericos/${item.id}`);
        const p = res.data;

        // 👇 Extraer campos especiales desde "description"
        const { tamano_pantalla, soporte, tecnologia_pantalla, image_url } =
          this.parseDescription(p.description, p.type);

        // 🧠 Asegurar parseo del log y enriquecer nombres
        let parsedLog = typeof p.log === "string" ? JSON.parse(p.log) : (p.log || []);
        parsedLog = await this.enrichLogWithNames(parsedLog);  // ✅ <- AQUÍ

        this.perifericoSeleccionado = {
          ...p,
          nombre: p.name,
          tipo: p.type,
          marca: p.brand,
          modelo: p.model,
          tamano_pantalla,
          soporte,
          tecnologia_pantalla,
          log: parsedLog,
          image_url: p.image_url || image_url || "",
          imagenFile: null
        };

        this.dialogDetallePeriferico = true;
        this.tabDetalle = 0;
        this.obtenerColaboradores();
      } catch (err) {
        console.error("❌ Error al obtener detalle actualizado:", err);
        this.snackbarMensaje = "❌ Error al cargar el periférico.";
        this.snackbarColor = "error";
        this.snackbar = true;
      }
    },
    abrirFormularioAgregar() {
      if (!this.puedeGestionarPerifericos) {
        this.dialogSinPermisos = true;
        return;
      }
      this.dialogAgregar = true;
    },
    async crearPeriferico() {
      const { tipo, marca, modelo, cantidad, tamano_pantalla, soporte, tecnologia_pantalla } = this.nuevoPeriferico;
      const nombre = this.normalizeNombre(this.nuevoPeriferico.nombre);

      if (!nombre || !tipo || !marca || !modelo || !cantidad) {
        this.snackbarMensaje = "⚠️ Completa todos los campos obligatorios.";
        this.snackbarColor = "error";
        this.snackbar = true;
        return;
      }

      if (tipo === "Monitor" && (!tamano_pantalla || !soporte || !tecnologia_pantalla)) {
        this.snackbarMensaje = "⚠️ Completa los campos para monitores.";
        this.snackbarColor = "error";
        this.snackbar = true;
        return;
      }

      try {
        const user = `${this.usuario?.name || "desconocido"} ${this.usuario?.surname || ""}`.trim();
        const description = this.buildDescription({
          type: tipo,
          tamano_pantalla,
          soporte,
          tecnologia_pantalla,
          fallbackDescription: ""
        });

        const payloadBase = {
          name: this.clampVarchar100(nombre),
          type: this.clampVarchar100(tipo),
          brand: this.clampVarchar100(marca),
          model: this.clampVarchar100(modelo),
          description: this.clampVarchar100(description)
        };

        for (let i = 0; i < cantidad; i++) {
          await axios.post(`${API_BASE}/perifericos`, {
            ...payloadBase
          }, {
            headers: {
              "user-name": user
            }
          });
        }

        this.snackbarMensaje = `✅ Se agregaron ${cantidad} periférico${cantidad > 1 ? "s" : ""}.`;
        this.snackbarColor = "success";
        this.snackbar = true;

        if (this.nuevoPeriferico.imagenFile) {
          try {
            await this.subirImagenPeriferico({
              file: this.nuevoPeriferico.imagenFile,
              name: payloadBase.name,
              type: payloadBase.type,
              brand: payloadBase.brand,
              model: payloadBase.model
            });
          } catch (errImg) {
            console.error("❌ Error al subir imagen:", errImg);
            const msg = errImg?.response?.data?.error || errImg?.message || "Error desconocido";
            this.snackbarMensaje = `✅ Periférico(s) agregado(s), pero no se pudo subir la imagen: ${msg}`;
            this.snackbarColor = "warning";
            this.snackbar = true;
          }
        }

        this.obtenerPerifericos();
        this.reiniciarFormulario();
        this.dialogAgregar = false;
      } catch (error) {
        console.error("❌ Error al agregar periférico:", error);
        this.snackbarMensaje = error?.response?.data?.error || "❌ Error al agregar el periférico.";
        this.snackbarColor = "error";
        this.snackbar = true;
      }
    },

    reiniciarFormulario() {
      this.nuevoPeriferico = {
        nombre: "",
        tipo: "",
        marca: "",
        modelo: "",
        cantidad: 1,
        tamano_pantalla: "",
        soporte: "",
        tecnologia_pantalla: "",
        imagen: "",
        imagenFile: null,
      };
    },
    autocompletarPeriferico(valor) {
      const nombre = this.normalizeNombre(valor);
      if (!nombre) return;
      this.nuevoPeriferico.nombre = nombre;
      const nombreLower = nombre.toLowerCase();
      const match = this.perifericosUnicosPorNombre.find(p => (p.nombre || "").toLowerCase() === nombreLower);
      if (!match) return;

      this.nuevoPeriferico.tipo = match.tipo || "";
      this.nuevoPeriferico.marca = match.marca || "";
      this.nuevoPeriferico.modelo = match.modelo || "";

      const { tamano_pantalla, soporte, tecnologia_pantalla, image_url } = this.parseDescription(
        match.description,
        match.tipo
      );
      this.nuevoPeriferico.tamano_pantalla = tamano_pantalla;
      this.nuevoPeriferico.soporte = soporte;
      this.nuevoPeriferico.tecnologia_pantalla = tecnologia_pantalla;
      this.nuevoPeriferico.imagen = match.image_url || image_url || "";
      this.nuevoPeriferico.imagenFile = null;
    },
    normalizeNombre(valor) {
      if (!valor) return "";
      if (typeof valor === "string") return valor.trim();
      if (typeof valor === "object") {
        if (valor.nombre) return String(valor.nombre).trim();
        if (valor.label) return String(valor.label).trim();
      }
      return String(valor).trim();
    },
    parseDescription(description, type) {
      let tamano_pantalla = "";
      let soporte = "";
      let tecnologia_pantalla = "";
      let image_url = "";

      if (!description) {
        return { tamano_pantalla, soporte, tecnologia_pantalla, image_url };
      }

      if (typeof description === "string") {
        try {
          const parsed = JSON.parse(description);
          if (parsed && typeof parsed === "object") {
            const monitor = parsed.monitor || {};
            tamano_pantalla = monitor.tamano_pantalla || parsed.tamano_pantalla || "";
            soporte = monitor.soporte || parsed.soporte || "";
            tecnologia_pantalla = monitor.tecnologia_pantalla || parsed.tecnologia_pantalla || "";
            image_url = parsed.image_url || parsed.imageUrl || "";
            return { tamano_pantalla, soporte, tecnologia_pantalla, image_url };
          }
        } catch (e) {
          // continuar con el formato legacy
        }
      }

      if (description && type === "Monitor") {
        const regex = /Tamaño:\s*(.+?),?\s*Soporte:\s*(.+?),?\s*Tecnología:\s*(.+)/i;
        const match = String(description).match(regex);
        tamano_pantalla = match?.[1] || "";
        soporte = match?.[2] || "";
        tecnologia_pantalla = match?.[3] || "";
      }

      return { tamano_pantalla, soporte, tecnologia_pantalla, image_url };
    },
    buildDescription({ type, tamano_pantalla, soporte, tecnologia_pantalla, fallbackDescription }) {
      const isMonitor = type === "Monitor";

      let desc = fallbackDescription || "";
      if (isMonitor) {
        desc = `Tamaño: ${tamano_pantalla || ""}, Soporte: ${soporte || ""}, Tecnología: ${tecnologia_pantalla || ""}`;
      }
      return desc.slice(0, 100);
    },
    clampVarchar100(value) {
      if (value === null || value === undefined) return value;
      return String(value).slice(0, 100);
    },
    manejarImagenSeleccionada(file) {
      const selected = Array.isArray(file) ? file[0] : file;
      if (!selected) {
        this.nuevoPeriferico.imagen = "";
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        this.nuevoPeriferico.imagen = reader.result || "";
      };
      reader.readAsDataURL(selected);
    },
    manejarImagenEdicion(file) {
      const selected = Array.isArray(file) ? file[0] : file;
      if (!selected) {
        this.perifericoSeleccionado.image_url = "";
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        this.perifericoSeleccionado.image_url = reader.result || "";
      };
      reader.readAsDataURL(selected);
    },
    getPeripheralImage(periferico) {
      if (periferico?.image_url) return periferico.image_url;
      return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMzIwJyBoZWlnaHQ9JzE4MCcgdmlld0JveD0nMCAwIDMyMCAxODAnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zyc+PHJlY3Qgd2lkdGg9JzMyMCcgaGVpZ2h0PScxODAnIGZpbGw9JyNlMmU4ZjAnLz48ZyBmaWxsPScjOTRhM2I4Jz48Y2lyY2xlIGN4PScxNjAnIGN5PSc3MCcgcj0nMzAnLz48cmVjdCB4PSc5MCcgeT0nMTE1JyB3aWR0aD0nMTQwJyBoZWlnaHQ9JzIwJyByeD0nNCcvPjwvZz48dGV4dCB4PScxNjAnIHk9JzE1NScgZm9udC1mYW1pbHk9J0FyaWFsJyBmb250LXNpemU9JzE0JyB0ZXh0LWFuY2hvcj0nbWlkZGxlJyBmaWxsPScjNjM3Mzg5Jz5TaW4gaW1hZ2VuPC90ZXh0Pjwvc3ZnPg==";
    },
    async subirImagenPeriferico({ file, name, type, brand, model }) {
      if (!file) return;
      const formData = new FormData();
      formData.append("imagen", file);
      formData.append("name", name);
      formData.append("type", type);
      formData.append("brand", brand);
      formData.append("model", model);

      await axios.post(`${API_BASE}/perifericos/imagen`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    },
    async agregarPeriferico(periferico) {
      try {
        const requests = [];
        for (let i = 0; i < periferico.cantidad; i++) {
          requests.push(axios.post(`${API_BASE}/perifericos`, periferico));
        }
        await Promise.all(requests);
        await this.obtenerPerifericos();
      } catch (error) {
        console.error("❌ Error al agregar periférico:", error);
      }
    },
    abrirDialogoConfirmarEliminar(periferico) {
      this.perifericoSeleccionado = periferico;
      this.dialogConfirmarEliminarUno = true;
    },
    // 🔹 Confirma y elimina el periférico seleccionado
    async confirmarEliminarPeriferico() {
      try {
        const { id } = this.perifericoSeleccionado;

        await axios.delete(`${API_BASE}/perifericos/${id}`, {
          headers: {
            "user-name": `${this.usuario?.name || ""} ${this.usuario?.surname || ""}`.trim()
          }
        });


        this.snackbarMensaje = "🗑️ Periférico eliminado correctamente.";
        this.snackbarColor = "success";
        this.snackbar = true;

        this.dialogConfirmarEliminarUno = false;
        this.dialogDetallePeriferico = false;

        this.perifericoSeleccionado = {};

        await this.obtenerPerifericos(); // recarga lista
      } catch (error) {
        console.error("❌ Error al eliminar periférico:", error);
        this.snackbarMensaje = "❌ No se pudo eliminar el periférico.";
        this.snackbarColor = "error";
        this.snackbar = true;
      }
    },
    async eliminarUno(periferico) {
      try {
        await axios.delete(`${API_BASE}/perifericos/uno`, {
          params: { nombre: periferico.nombre }
        });
        this.obtenerPerifericos();
      } catch (error) {
        console.error("❌ Error al eliminar periférico:", error);
      }
    },
    async obtenerColaboradores() {
      try {
        const res = await axios.get(`${API_BASE}/colaboradores`);

        console.log("📦 Colaboradores:", res.data); // Verifica en consola

        this.colaboradores = res.data
          .filter(c => c.status === "activo")
          .map(c => ({
            id: c.id,
            nombre_completo: `${c.name} ${c.surname}`
          }));
      } catch (error) {
        console.error("❌ Error al obtener colaboradores:", error);
      }
    },
    async obtenerPerifericosDisponibles() {
      try {
        const res = await axios.get(`${API_BASE}/perifericos/disponibles`);
        this.perifericosDisponibles = res.data.filter(p => p.colaborador_id === null);
      } catch (error) {
        console.error("❌ Error al obtener periféricos disponibles:", error);
      }
    },
    async asignarPerifericoDesdeDetalle() {
      if (!this.puedeGestionarPerifericos) {
        this.snackbarMensaje = "⛔ No tienes permisos para asignar periféricos.";
        this.snackbarColor = "error";
        this.snackbar = true;
        return;
      }

      if (!this.perifericoSeleccionado?.id || !this.colaboradorSeleccionado) {
        this.snackbarMensaje = "⚠️ Debes seleccionar un periférico y un colaborador.";
        this.snackbarColor = "error";
        this.snackbar = true;
        return;
      }

      try {
        const res = await axios.put(
          `${API_BASE}/perifericos/asignar/${this.perifericoSeleccionado.id}`,
          { colleague_id: this.colaboradorSeleccionado },
          {
            headers: {
              "user-name": `${this.usuario?.name || ""} ${this.usuario?.surname || ""}`.trim(),
            },
          }
        );

        this.snackbarMensaje = res.data?.mensaje || "✅ Asignación exitosa.";
        this.snackbarColor = "success";
        this.snackbar = true;

        await this.obtenerPerifericos();
        this.dialogDetallePeriferico = false;
      } catch (error) {
        console.error("❌ Error al asignar periférico:", error);
        this.snackbarMensaje = error.response?.data?.error || "❌ Error al asignar periférico.";
        this.snackbarColor = "error";
        this.snackbar = true;
      }
    },
    manejarClickAgregar() {
      if (this.puedeGestionarPerifericos) {
        this.dialogAgregar = true;
      } else {
        this.dialogSinPermisos = true;
      }
    },
    async guardarCambiosPeriferico() {
      if (!this.puedeGestionarPerifericos) {
        this.snackbarMensaje = "⛔ No tienes permisos para modificar periféricos.";
        this.snackbarColor = "error";
        this.snackbar = true;
        return;
      }

      try {
        const payload = {
          name: this.clampVarchar100(this.perifericoSeleccionado.nombre),
          type: this.clampVarchar100(this.perifericoSeleccionado.tipo),
          brand: this.clampVarchar100(this.perifericoSeleccionado.marca),
          model: this.clampVarchar100(this.perifericoSeleccionado.modelo),
          status: this.perifericoSeleccionado.status,
          description: this.clampVarchar100(this.buildDescription({
            type: this.perifericoSeleccionado.tipo,
            tamano_pantalla: this.perifericoSeleccionado.tamano_pantalla,
            soporte: this.perifericoSeleccionado.soporte,
            tecnologia_pantalla: this.perifericoSeleccionado.tecnologia_pantalla,
            fallbackDescription: this.perifericoSeleccionado.description || ""
          }))
        };

        await axios.put(`${API_BASE}/perifericos/${this.perifericoSeleccionado.id}`, payload, {
          headers: {
            "user-name": `${this.usuario?.name || ""} ${this.usuario?.surname || ""}`.trim(),
          },
        });

        this.snackbarMensaje = "✅ Periférico actualizado correctamente.";
        this.snackbarColor = "success";
        this.snackbar = true;

        if (this.perifericoSeleccionado.imagenFile) {
          try {
            await this.subirImagenPeriferico({
              file: this.perifericoSeleccionado.imagenFile,
              name: payload.name,
              type: payload.type,
              brand: payload.brand,
              model: payload.model,
            });
          } catch (errImg) {
            console.error("❌ Error al subir imagen:", errImg);
            const msg = errImg?.response?.data?.error || errImg?.message || "Error desconocido";
            this.snackbarMensaje = `✅ Periférico guardado, pero no se pudo subir la imagen: ${msg}`;
            this.snackbarColor = "warning";
            this.snackbar = true;
          }
        }

        this.dialogDetallePeriferico = false;
        await this.obtenerPerifericos();
      } catch (error) {
        console.error("❌ Error al actualizar periférico:", error);
        this.snackbarMensaje = error?.response?.data?.error || "❌ Error al actualizar el periférico.";
        this.snackbarColor = "error";
        this.snackbar = true;
      }
    },
    abrirFormularioAsignar() {
      this.dialogAsignar = true;
      this.obtenerColaboradores();
      this.obtenerPerifericosDisponibles();
    },

    actualizarCantidadEnLista(perifericoActualizado) {
      const index = this.perifericos.findIndex(p =>
        p.nombre === perifericoActualizado.nombre &&
        p.tipo === perifericoActualizado.tipo &&
        p.marca === perifericoActualizado.marca &&
        p.modelo === perifericoActualizado.modelo
      );

      if (index !== -1) {
        this.perifericos[index].cantidad = perifericoActualizado.cantidad;
      }
    },

    async enrichLogWithNames(log) {
      const ids = new Set();

      for (const entry of log) {
        if (entry.from && typeof entry.from === "number") ids.add(entry.from);
        if (entry.to && typeof entry.to === "number") ids.add(entry.to);
      }

      if (ids.size === 0) return log;

      const response = await axios.get(`${API_BASE}/colaboradores`);
      const colaboradorMap = {};
      for (const col of response.data) {
        colaboradorMap[col.id] = `${col.name} ${col.surname}`;
      }

      return log.map(entry => ({
        ...entry,
        from: typeof entry.from === "number" ? colaboradorMap[entry.from] || `ID ${entry.from}` : entry.from,
        to: typeof entry.to === "number" ? colaboradorMap[entry.to] || `ID ${entry.to}` : entry.to
      }));
    },

    volverInicio() {
      this.$router.push("/inicio").catch(() => { });
    }
  },

  mounted() {
    const usuarioGuardado = sessionStorage.getItem('usuario');
    if (usuarioGuardado) {
      this.usuario = JSON.parse(usuarioGuardado);
      console.log("👤 Usuario cargado desde sessionStorage:", this.usuario);
    } else {
      console.warn("⚠️ No se encontró usuario en sessionStorage.");
    }

    this.obtenerPerifericos();
  }
};
</script>

<style scoped>
.dashboard-container {
  padding: 12px;
}

.peripheral-card {
  cursor: pointer;
  user-select: none;
  transition: transform 0.2s ease, opacity 0.2s ease;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.12);
}

.peripheral-card--dark {
  background: linear-gradient(135deg, #1f2937, #0b1220);
  border: 1px solid rgba(255, 255, 255, 0.10);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.25);
}

.peripheral-card--light {
  background: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 10px 18px rgba(0, 0, 0, 0.10);
}

.peripheral-card--hover {
  transform: translateY(-4px);
}

.peripheral-image {
  cursor: pointer;
}

.peripheral-status {
  display: flex;
  justify-content: flex-end;
  padding: 8px;
}

.peripheral-body {
  padding: 12px 14px 14px 14px;
  color: inherit;
}

.peripheral-card--light .peripheral-body {
  color: #111827;
}

.title {
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.2px;
  margin-bottom: 10px;
}

.meta {
  font-size: 12px;
  opacity: 0.9;
  line-height: 1.5;
}

.assigned {
  margin-top: 12px;
  font-size: 12px;
  display: flex;
  align-items: center;
  opacity: 0.95;
}

.k {
  opacity: 0.8;
  margin-right: 4px;
}

.v {
  font-weight: 700;
}

.v-dialog.v-dialog--active {
  overflow: hidden !important;
}

.dialog-scroll-container {
  flex: 1 1 auto;
  overflow-y: auto;
  max-height: 60vh;
  padding: 16px;
  box-sizing: border-box;
  scroll-behavior: smooth;
}
</style>
